import gql from 'graphql-tag'

export const UpdateRole = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput) {
        updateUserProfile(input: $input) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            loanApplicationId
            countryId
            lastLoginDate
            givenConsentDate
            removedConsentDate
            notifyEmail
            notifyPhone
            payableAddress
            loanApplicationId
        }
    }
`
